Bingo.DashboardContracts = {};
Bingo.DashboardContracts.init = () => {
    // Change filter type
    $(document).on('click', '.js-typeFilter__dropdownMenu .js-filterTag', function (e) {
        e.preventDefault();

        $('.js-typeFilter__dropdownMenu .js-filterTag').removeClass('-active d-none d-lg-inline-block');
        $(this).addClass('-active d-none d-lg-inline-block');
        $('.js-filterButton').html($(this).html()).attr('data-filter-type', $(this).attr('data-filter-type'));

        const typeId = $(this).data('typeId');
        const statusId = $('.js-statusFilter__dropdownMenu .js-filterTag.-active').data('statusId');
        const url = $('.js-dashboard').data('listUrl');

        $.nette.ajax({
            type: 'GET',
            url,
            data: {
                typeId,
                statusId,
            },
        });
    });
    // Change filter status
    $(document).on('click', '.js-statusFilter__dropdownMenu .js-filterTag', function (e) {
        e.preventDefault();

        $('.js-statusFilter__dropdownMenu .js-filterTag').removeClass('-active d-none d-lg-inline-block');
        $(this).addClass('-active d-none d-lg-inline-block');
        $('.js-filterButton').html($(this).html()).attr('data-filter-state', $(this).attr('data-filter-state'));

        const typeId = $('.js-typeFilter__dropdownMenu .js-filterTag.-active').data('typeId');
        const statusId = $(this).data('statusId');
        const url = $('.js-dashboard').data('listUrl');

        $.nette.ajax({
            type: 'GET',
            url,
            data: {
                typeId,
                statusId,
            },
        });
    });
};
